import { first } from 'rxjs/operators';
import { TenantService } from './tenant.service';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';


@Injectable({ providedIn: 'root' })
export class MenuItemGuard implements CanActivate {
    tenant: any;
    unrestricted: boolean;
    briefingsOnly: boolean;

    constructor(private router: Router, tenantService: TenantService) {
        tenantService.getUnauthTenantInfo().pipe(first()).subscribe(tenant => {
            this.tenant = tenant;
            this.unrestricted = !this.tenant.settings.clientDigestMenuOptions
            this.briefingsOnly = !this.unrestricted && this.tenant.settings.clientDigestMenuOptions.length === 0;
        });
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const isEnabled = this.menuEnabled(route.routeConfig.path);
        if (!this.unrestricted && !isEnabled && this.briefingsOnly) {
            this.router.navigate(['briefings']);
        } else if (!this.unrestricted && !isEnabled && !this.briefingsOnly) {
            this.router.navigate(['/digest', this.tenant.settings.clientDigestMenuOptions[0]]);
        } 
        return true;
    }

    menuEnabled(item) {
        return this.tenant && this.tenant.settings && 
        (!this.tenant.settings.clientDigestMenuOptions || this.tenant.settings.clientDigestMenuOptions.indexOf(item) !== -1);
    }
}